export const GET_CHECK_URLS = "GET_CHECK_URLS";
export const RESET_CHECK_URLS = "RESET_CHECK_URLS";
export const SET_CHECK_URLS_REQUEST_STATUS = "SET_CHECK_URLS_REQUEST_STATUS";
